import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "loading-container"
};
import { ref } from "vue";
const MIN_SHOW_MS = 350; // 建议 250~500 自己调
const FADE_MS = 220; // 要和 CSS transition 时间一致

export default {
  __name: 'index',
  setup(__props, {
    expose: __expose
  }) {
    const show = ref(false);

    // ✅ 你要的“哪怕加载很快也有过渡”的关键：最小展示时长
    let showAt = 0;
    let hideTimer = null;
    let afterLeaveCb = null;
    const lockScroll = () => {
      document.body.style.overflow = "hidden";
    };
    const unlockScroll = () => {
      document.body.style.overflow = "";
    };
    const showLoading = () => {
      if (hideTimer) {
        clearTimeout(hideTimer);
        hideTimer = null;
      }
      afterLeaveCb = null;
      if (!show.value) {
        show.value = true;
        showAt = Date.now();
        lockScroll();
      } else {
        // 已经显示时，刷新起始时间，避免马上 hide 造成闪
        showAt = Date.now();
      }
    };

    // ✅ 支持回调：你的指令里就是这么用的 :contentReference[oaicite:1]{index=1}
    const hideLoading = cb => {
      afterLeaveCb = typeof cb === "function" ? cb : null;
      const elapsed = Date.now() - showAt;
      const wait = Math.max(0, MIN_SHOW_MS - elapsed);
      if (hideTimer) clearTimeout(hideTimer);
      hideTimer = setTimeout(() => {
        show.value = false; // 触发 leave 动画
        hideTimer = null;
      }, wait);
    };
    const onAfterLeave = () => {
      unlockScroll();
      if (afterLeaveCb) {
        afterLeaveCb();
        afterLeaveCb = null;
      }
    };
    __expose({
      show,
      showLoading,
      hideLoading
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createBlock(_Transition, {
        name: "sy-fade",
        onAfterLeave: onAfterLeave
      }, {
        default: _withCtx(() => [show.value ? (_openBlock(), _createElementBlock("div", _hoisted_1, _cache[0] || (_cache[0] = [_createElementVNode("div", {
          class: "loader"
        }, null, -1), _createElementVNode("div", {
          class: "tips"
        }, "正在快马加鞭的加载中....", -1)]))) : _createCommentVNode("", true)]),
        _: 1
      });
    };
  }
};